<template>
    <div v-if="formbuilder && formbuilder.length">
        <div v-for="(form, index) in formbuilder"
             :key="index"
             v-bind="form"
             class="component-form-builder"
             v-bind:style="{
                     'background' : form.component != 'Separator' ? 'white' : '#eeeeee'
                 }">
            <component :is="form.component"
                       :currentField="form"
                       :canEdit="editable"
                       :showIcon="displayIcon">
            </component>
        </div>
    </div>

</template>

<script>
    import { FormBuilder } from "./form_elements/formbuilder";

    export default {
        name: "display-form-builder",
        store: ['forms' , 'activeForm' , 'element'],
        props : {
            content : Array,
            showIcon: null,
            canEdit: null,
        },
        components: FormBuilder.$options.components,
        data(){
            return {
                formbuilder : this.content,
                displayIcon : this.showIcon,
                editable : this.canEdit
            }
        },
        mounted() {
            this.forms = this.formbuilder;
        }
    }
</script>

<style scoped>

</style>
